<template>
  <div id="app" class="align-center">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/>
    <SessionTime ref="session"/>
  </div>
</template>


<script>
import SessionTime from '@/components/SessionTime/SessionTime.vue'

export default {
  components: {
    SessionTime
  }
}

</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.align-center {
  text-align: center;
}

</style>